// Types
import { TYPES } from "../types/types.constants";

/**
 * Setea el error generado
 * @param {Object} error Objeto con el detalle del error
 */
export const setErrorAction = (error) => {

    return {

        type: TYPES.APP.SET_ERROR,
        payload: {
            status: error.status,
            message: error.message
        }
    };
};

/**
 * Limpia el error
 */
export const resetErrorAction = () => {

    return {

        type: TYPES.APP.RESET_ERROR
    };
};

/**
 * Setea una referencia de página
 * En principio, necesario para determinar si se viene del historial hacia el detalle
 * @param {String} pageRef Referencia de la página
 */
export const setPageRefAction = (pageRef) => {

    return {

        type: TYPES.APP.SET_PAGE_REF,
        payload: pageRef
    };
};

/**
 * Limpia la referencia de página
 */
export const resetPageRefAction = () => {

    return {

        type: TYPES.APP.RESET_PAGE_REF
    };
};

/**
 * Limpia todo el state
 */
export const resetStateAction = () => {

    return {

        type: TYPES.APP.RESET
    };
};

/**
 * Setea la configuración obtenida del GONOGO en Redux
 * @param {Object} config Configuración relacionada al GONOGO
 */
export const setGoNoGoAction = (config) => {

    return {

        type: TYPES.APP.SET_GONOGO,
        payload: config
    };
};

/**
 * Setea el flag de loading en REDUX
 * @param {Boolean} loading Estado del loading
 */
export const setLoadingAction = (loading) => {

    return {

        type: TYPES.APP.SET_LOADING,
        payload: loading
    };
};